export default "__VITE_ASSET__BDSbjIkZ__"